// extracted by mini-css-extract-plugin
export default {"modal":"SimpleModal_modal__9nXHv","window":"SimpleModal_window__tJtf9"};